import Route from '@ember/routing/route';

export default class AuthenticatedAccountActivityLoansRoute extends Route {}
